<template>
  <div>
    <v-layout wrap align-center>
      <v-flex xs9>{{ $t('Set time') }}</v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn v-if="!isEdit" outline icon color="primary" @click="isEdit = true">
          <v-icon> edit </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-card class="mt-2">
      <div class="pa-2 hidden-xs-only">
        <v-layout wrap>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Date_1') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Open at') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Close at') }}</v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <template v-for="(time, key) in timetable">
        <open-time-bot-item
          :key="key"
          v-model="timetable[key]"
          :name="key"
          :is-edit="isEdit"
        ></open-time-bot-item>
      </template>
    </v-card>
    <div v-if="isEdit" class="text-xs-center mt-4">
      <v-btn color="grey" outline @click="onCancelTimeTable">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSaveTimeTable">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import OpenTimeBotItem from './OpenTimeBotItem'
export default {
  components: {
    OpenTimeBotItem
  },
  props: ['channel'],
  data() {
    return {
      isEdit: false,
      timetable: {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.getTimeToUseBot()
  },
  methods: {
    getTimeToUseBot: function () {
      const vm = this
      return new Promise((resolve, reject) => {
        api.getTimeToUseBot({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            if (vm.selectedBot && vm.selectedBot.type === 'gpf') {
              let res
              switch (vm.channel) {
                case 'facebook':
                  res = response.data.time_to_use_bot_facebook
                  break
                case 'line':
                  res = response.data.time_to_use_bot_line
                  break
                case 'webchat':
                  res = response.data.time_to_use_bot_webchat
                  break
                case 'app':
                  res = response.data.time_to_use_bot_app
                  break
                default:
                  res = response.data.timetousebot
                  break
              }

              if (res) {
                vm.timetable = JSON.parse(res)
              } else {
                vm.timetable = {
                  Monday: { status: true, openat: null, closeat: null },
                  Tuesday: { status: true, openat: null, closeat: null },
                  Wednesday: { status: true, openat: null, closeat: null },
                  Thursday: { status: true, openat: null, closeat: null },
                  Friday: { status: true, openat: null, closeat: null },
                  Saturday: { status: true, openat: null, closeat: null },
                  Sunday: { status: true, openat: null, closeat: null }
                }
              }
              vm.cached_timetable = JSON.stringify(vm.timetable)
            } else {
              if (response.data.timetousebot) {
                if (response.data.timetousebot) {
                  vm.timetable = JSON.parse(response.data.timetousebot)
                } else {
                  vm.timetable = {
                    Monday: { status: true, openat: null, closeat: null },
                    Tuesday: { status: true, openat: null, closeat: null },
                    Wednesday: { status: true, openat: null, closeat: null },
                    Thursday: { status: true, openat: null, closeat: null },
                    Friday: { status: true, openat: null, closeat: null },
                    Saturday: { status: true, openat: null, closeat: null },
                    Sunday: { status: true, openat: null, closeat: null }
                  }
                }

                vm.cached_timetable = JSON.stringify(vm.timetable)
              }
            }

            vm.cached_timetable = JSON.stringify(vm.timetable)
          }
          resolve()
        })
      })
    },
    onCancelTimeTable: function () {
      var vm = this
      vm.timetable = JSON.parse(vm.cached_timetable)
      vm.isEdit = false
    },
    onSaveTimeTable: function () {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then((result) => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }

          if (vm.selectedBot && vm.selectedBot.type === 'gpf') {
            let data = {
              pageid: this.selectedBot.pageid
            }

            switch (vm.channel) {
              case 'facebook':
                Object.assign(data, { time_to_use_bot_facebook: JSON.stringify(vm.timetable) })
                break
              case 'line':
                Object.assign(data, { time_to_use_bot_line: JSON.stringify(vm.timetable) })
                break
              case 'webchat':
                Object.assign(data, { time_to_use_bot_webchat: JSON.stringify(vm.timetable) })
                break
              case 'app':
                Object.assign(data, { time_to_use_bot_app: JSON.stringify(vm.timetable) })
                break
              default:
                Object.assign(data, { timetousebot: JSON.stringify(vm.timetable) })
                break
            }

            api.saveTimeToUseBot(data, function (error, response) {
              if (error) {
                reject(error)
              }
              vm.cached_timetable = JSON.stringify(vm.timetable)
              vm.isEdit = false
              resolve()
            })
          } else {
            let data = {
              timetousebot: JSON.stringify(vm.timetable),
              pageid: this.selectedBot.pageid
            }
            api.saveTimeToUseBot(data, function (error, response) {
              if (error) {
                reject(error)
              }
              vm.cached_timetable = JSON.stringify(vm.timetable)
              vm.isEdit = false
              resolve()
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ManageOpenTimeBot.vue